/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Meta_DescInputs */

const en_pc_tut_meta_desc = /** @type {(inputs: Pc_Tut_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn PdfCraft step by step: open and read PDFs, search, rotate and reorder pages, combine and split files, fill forms, open protected PDFs, use the CLI and shortcuts.`)
};

const zh_pc_tut_meta_desc = /** @type {(inputs: Pc_Tut_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一步步学会 PdfCraft：打开阅读 PDF、搜索、旋转与排序页面、合并与拆分文件、填写表单、打开加密 PDF、使用命令行和快捷键。`)
};

/**
* | output |
* | --- |
* | "Learn PdfCraft step by step: open and read PDFs, search, rotate and reorder pages, combine and split files, fill forms, open protected PDFs, use the CLI and ..." |
*
* @param {Pc_Tut_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_meta_desc = /** @type {((inputs?: Pc_Tut_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_meta_desc(inputs)
	return zh_pc_tut_meta_desc(inputs)
});
export { pc_tut_meta_desc as "pc.tut.meta_desc" }